
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Diagram, StatisticGraphicsEcoScore } from '@clients/bff';
import DiagramView from './DiagramView.vue';
import EcoScoreSection from '@components/shared/section/EcoScoreSection.vue';
import { namespace } from 'vuex-class';
import { TripLog } from '@/generated-clients/myTrips';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'DiagramsTab',
  components: {
    DiagramView,
    EcoScoreSection
  },
})
export default class DiagramsTab extends Vue {
  @Prop()
  private diagrams: Array<Diagram>;

  @Prop()
  private ecoScore: StatisticGraphicsEcoScore;

  @TriplogModule.Getter('getSelectedTriplog')
  private selectedTriplog: TripLog;

}
